import React from 'react'
import ReactDOM from 'react-dom/client'
// Base styles and shared components first, so screens' CSS comes after it.
import './index.css'
import App from './App'
import ErrorBoundary, { AppError, shouldReloadForUpdate } from './components/ErrorBoundary'
import { forgetWhereAt } from './context/whereAt'
import { UPDATE_READY, watchForUpdates } from './pwa/updates'

// Register the service worker (the only registration: vite.config.ts injects
// none), and ask for a newer one whenever the app comes back to the
// foreground. Without a service worker the app carries on online only.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    watchForUpdates({
      container: navigator.serviceWorker,
      doc: document,
      registration: navigator.serviceWorker.register('/sw.js'),
      onUpdate: () => window.dispatchEvent(new Event(UPDATE_READY)),
    })
  })
}

// After a deploy, a screen's code file from the old build no longer exists.
// Vite reports it here: reload once to pick up the new build. If that
// doesn't help (offline, or a real problem), the error boundaries take over.
window.addEventListener('vite:preloadError', (event) => {
  let storage: Storage | null = null
  try {
    storage = window.sessionStorage
  } catch {
    // No storage: never reload, so it can't loop.
  }
  if (shouldReloadForUpdate(storage)) {
    event.preventDefault()
    window.location.reload()
  }
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary
      fallback={() => (
        <AppError
          onReload={() => {
            forgetWhereAt()
            window.location.reload()
          }}
        />
      )}
    >
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
)
